import { memoize } from "lodash";
import { observable } from "mobx";

import getCoreTimingStore from "../core-timing-store";

class CoreTabStore {
  isFocused = observable.box<boolean>(true);
  focus = () => {
    this.isFocused.set(true);
    getCoreTimingStore().startCalculatingTimeOnFocus();
  };
  blur = async () => {
    this.isFocused.set(false);
    await getCoreTimingStore().sendActiveTimeAndResetData();
  };

  handleActivity = async (e: { type: string }) => {
    if (e?.type === "focus") {
      this.focus();
      return;
    }
    if (e?.type === "blur") {
      await this.blur();
      return;
    }
    if (e?.type === "visibilitychange") {
      if (document.hidden) {
        await this.blur();
        return;
      } else {
        this.focus();
        return;
      }
    }
  };
  handleActivityOnReload = async (e: BeforeUnloadEvent) => {
    const confirmationMessage = "o/";
    (e || window.event).returnValue = confirmationMessage;
    await this.blur();
    //Gecko + IE
    return confirmationMessage; //Webkit, Safari, Chrome
  };

  onStartListeners = () => {
    window.addEventListener("blur", this.handleActivity);
    window.addEventListener("focus", this.handleActivity);
    window.addEventListener("beforeunload", this.handleActivityOnReload);
  };
  onKillListeners = () => {
    window.removeEventListener("blur", this.handleActivity);
    window.removeEventListener("focus", this.handleActivity);
    window.removeEventListener("beforeunload", this.handleActivity);
  };
}
const getCoreTabStore = memoize(
  () => new CoreTabStore(),
  () => 1
);
export default getCoreTabStore;
